import { render, staticRenderFns } from "./PinSetup.html?vue&type=template&id=768eb5b3&scoped=true&"
import script from "./PinSetup.vue?vue&type=script&lang=ts&"
export * from "./PinSetup.vue?vue&type=script&lang=ts&"
import style0 from "./PinSetup.scss?vue&type=style&index=0&id=768eb5b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768eb5b3",
  null
  
)

export default component.exports